import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { TableCell } from 'uiKit/atoms/TableCell/TableCell';
import { TableRow } from 'uiKit/atoms/TableRow/TableRow';
import { IconButton } from 'uiKit/atoms/IconButton/IconButton';
import { KeyboardArrowDown } from 'uiKit/atoms/KeyboardArrowDown/KeyboardArrowDown';
import { KeyboardArrowUp } from 'uiKit/atoms/KeyboardArrowUp/KeyboardArrowUp';

export const AppTableRow = props => {
  const { row, settings } = props;
  const { Details } = settings;

  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TableRow data-testid="AppTableRow">
        <TableCell style={{ width: '16px' }}>
          <IconButton
            aria-label="expanded table row"
            size="small"
            className=""
            onClick={() => setOpen(!open)}
            data-testid="AppTableRowExpand"
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        {settings.columns.reduce((prev, item) => {
          if (item.isVisible) {
            prev.push(
              <TableCell key={`apptr_${row[settings.rowKey]}_${item.dataColumn}`} className="bns-text">
                {row[item.dataColumn]}
              </TableCell>
            );
          }
          return prev;
        }, [])}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12} data-testid="AppTableRowExpandedCell">
          <article className={cn('collapsable-article', { 'collapsable-article-active': open })}>
            {open ? <Details row={row} columns={settings.columns} /> : null}
          </article>
        </TableCell>
      </TableRow>
    </>
  );
};

AppTableRow.propTypes = {
  settings: PropTypes.shape({
    title: PropTypes.string,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        dataColumn: PropTypes.string,
        isVisible: PropTypes.bool,
        isSearchable: PropTypes.bool,
      })
    ),
    rowKey: PropTypes.string,
    searchCallback: PropTypes.func,
    Details: PropTypes.object,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  row: PropTypes.object.isRequired,
};

export default AppTableRow;
